export default function resolveUserRoles(roles) {
  if (roles.includes('ROLE_ADMIN')) return { icon: 'LockIcon', text: 'Administrator' }
  if (roles.includes('ROLE_MANAGER')) return { icon: 'BriefcaseIcon', text: 'Manager' }
  if (roles.includes('ROLE_TRAINER')) return { icon: 'PenToolIcon', text: 'Trener' }
  if (roles.includes('ROLE_EMPLOYEE')) return { icon: 'UserIcon', text: 'Pracownik' }
  if (roles.includes('ROLE_FORD_POLAND')) return { icon: 'AwardIcon', text: process.env.VUE_APP_ROLE_LABEL }
  return { icon: 'HelpCircleIcon', text: 'Nieznany' }
}
